export default "__VITE_ASSET__$N8lUkdj__"